// Modules
import React from 'react';
import PropTypes from 'prop-types';
// Styles
import * as styles from './PortfolioGallery.scss';
import PortfolioGalleryImage from './PortfolioGalleryImage/PortfolioGalleryImage';
import modifyImageLink from '../../../utils/modifyImageLink';
import { imageModifierTypes } from '../../../constants';
import buildVideoLinks from '../../../utils/buildVideoLinks';
import {
  isVideoPosterReady, shouldShowVideoStatusBadge, isImagePosterReady, shouldShowImageStatusBadge
} from '../../../utils/normalizeMediaStatus';
import VideoStatusBadge from '../../VideoStatusBadge/VideoStatusBadge';
import ImageStatusBadge from '../../ImageStatusBadge/ImageStatusBadge';

const PortfolioGallery = (props) => {
  const renderSlide = (image, idx) => {
    if (shouldShowImageStatusBadge(image)) {
      return (
        <div
          key={image.thumbnail}
          data-id={image.thumbnail}
          className={styles.slide}
        >
          <ImageStatusBadge className={styles.videoPlaceholder} status={image.status} error={image.error} />
        </div>
      );
    }

    if (!isImagePosterReady(image)) {
      return null;
    }

    const imageLink = modifyImageLink(image.thumbnail, imageModifierTypes.PORTFOLIO_THUMBNAIL);
    const clickHandler = () => props.openLightbox(idx);

    return (
      <div
        key={image.thumbnail}
        data-id={image.thumbnail}
        className={styles.slide}
        onClick={clickHandler}
      >
        <PortfolioGalleryImage src={imageLink} alt="" />
      </div>
    );
  };

  const renderVideoSlide = (video, idx) => {
    if (shouldShowVideoStatusBadge(video)) {
      return (
        <div
          key={video.id}
          data-id={video.id}
          className={styles.slide}
        >
          <VideoStatusBadge className={styles.videoPlaceholder} status={video.status} error={video.error} />
        </div>
      );
    }

    if (!isVideoPosterReady(video)) {
      return null;
    }
    const posterLinks = buildVideoLinks(video);
    const poster = posterLinks?.portfolioThumbnail || posterLinks.thumbnail;
    const clickHandler = () => props.openLightbox(props.images?.length + idx);

    return (
      <div
        key={poster}
        data-id={poster}
        className={styles.slide}
        onClick={clickHandler}
      >
        <img
          src={poster}
          alt=""
        />
        <div className={styles.playIcon} />
      </div>
    );
  };

  return (
    <div className={styles.wrapSliders}>
      {props.images.map(renderSlide)}
      {props.videos?.map(renderVideoSlide)}
    </div>
  );
};

PortfolioGallery.propTypes = {
  images: PropTypes.array,
  videos: PropTypes.array,
  openLightbox: PropTypes.func
};

export default PortfolioGallery;
